export const query = `query getPosts($site: [String] = "default", $section: [String] = "posts", $relatedToSection: [String] = ["blogCategories", "blogTags", "blogAuthors"], $title: [String] = "", $id: [QueryArgument] = "not 1", $limit: Int = 9, $offset: Int = 0) {
  entryCount(
    site: $site
    section: $section
    relatedToEntries: [{site: $site, section: $relatedToSection, title: $title}]
  )
  entries(
    site: $site
    section: $section
    id: $id
    orderBy: "postDate DESC"
    relatedToEntries: [{site: $site, section: $relatedToSection, title: $title}]
    limit: $limit
    offset: $offset
  ) {
    typeHandle
    ... on posts_default_Entry {
      id
      siteId
      siteHandle
      title
      slug
      uri
      url
      tags: blogTags(limit: 2) {
        title
        slug
        url
      }
      blogFeaturedImage {
        format
        width
        height
        src: url
        alt: title
        title
      }
    }
  }
}`;